import { css, cva, cx } from '@mildang/styled-system/css';
import Text from '@mildang/design-system-legacy/esm/components/atoms/Text';
import { SystemStyleObject } from '@mildang/styled-system/types';

const chipStyle = cva({
  base: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    alignContent: 'center',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '0px 6px',
    width: 'fit-content',
    height: '20px',
    borderRadius: '20px',
  },
  variants: {
    variant: {
      main: {
        background: 'error.7',
      },
      sub: {
        background: 'info.2',
        border: '1px solid',
        borderColor: 'info.5',
      },
    },
  },
  defaultVariants: {
    variant: 'main',
  },
});

const textStyle = css({
  lineHeight: '1em',
});

export interface ChatUnreadCountBadgeProps {
  unreadCount: number;
  variant?: 'main' | 'sub';
  panda?: SystemStyleObject;
}

export const ChatUnreadCountBadge = ({ unreadCount, variant = 'main', panda }: ChatUnreadCountBadgeProps) => {
  if (unreadCount === 0) return null;
  return (
    <div className={cx(chipStyle({ variant }), css(panda))}>
      <Text variant="caption1-M" color={variant === 'sub' ? 'info.10' : 'common.1'} className={textStyle}>
        {unreadCount > 99 ? '99+' : unreadCount}
      </Text>
    </div>
  );
};
